import { Form, Modal } from 'antd'
import { useDiscountSchemaTranslation } from 'hooks/translation/useDiscountSchemaTranslation'
import { DiscountSchema } from 'models/discount'
import { PricingSchemaPayload } from '../../../../models/price'
import { Tenant } from '../../../../models/tenant'
import EditDiscountSchemaSection from './edit-discount-schema-section'

interface props {
  tenant: Tenant
  selectedDiscountSchema: DiscountSchema
  selectedPricingSchema: PricingSchemaPayload | undefined
  discounts: DiscountSchema[]
  discountId: number
  onCancel: () => void
  onOk: () => void
}

const EditDiscountSchemaModal: React.FC<props> = ({
  tenant,
  selectedDiscountSchema,
  selectedPricingSchema,
  discounts,
  discountId,
  onCancel,
  onOk,
}) => {
  const [form] = Form.useForm()
  const { discountPlanModalTitleText } = useDiscountSchemaTranslation()

  const afterClose = () => form.resetFields()

  return (
    <Modal
      title={<h5 className="heading-05-regular">{discountPlanModalTitleText}</h5>}
      visible={true}
      onCancel={onCancel}
      width={1034}
      afterClose={afterClose}
      footer={null}
    >
      <EditDiscountSchemaSection
        tenant={tenant}
        selectedDiscountSchema={selectedDiscountSchema}
        selectedPricingSchema={selectedPricingSchema}
        discounts={discounts}
        discountId={discountId}
        onCancel={onCancel}
        onOk={onOk}
      />
    </Modal>
  )
}

export default EditDiscountSchemaModal
